import React from "react";
import { FooterContainer, PoweredContainer, PoweredText, TermsText } from "./styles";
import { useTranslation } from "react-i18next";
import SvgIconUrl from "../../../helpers/SvgIcon/SvgIconUrl";
import { isMoving } from "Util/validation";
import { useAppState } from "Context/StateContext";
import { LINKS } from "../../../constants";

const SHIPEEZIICON = require("Assets/img/shipeezi-logo.svg");

type Props = {
  leftMargin?: number | string;
};

export const Footer: React.FC<Props> = ({ leftMargin = 0 }) => {
  const { t: translate } = useTranslation();
  const { currentUser } = useAppState();

  const handleNavigateTerms = () => {
    window.open(LINKS.termsOfUse, "_blank");
  };

  const appliedLeft = isMoving(currentUser?.company) ? leftMargin : 0;

  return (
    <FooterContainer leftMargin={appliedLeft}>
      <PoweredContainer>
        <PoweredText>{translate("poweredBy")}</PoweredText>
        <SvgIconUrl src={SHIPEEZIICON} width={98} height={20} color="#98A2B3" />
      </PoweredContainer>
      <TermsText onClick={handleNavigateTerms}>{translate("TermsConditions")}</TermsText>
    </FooterContainer>
  );
};
